import { render, staticRenderFns } from "./SalesmanEdit.vue?vue&type=template&id=35b23434&scoped=true"
import script from "./SalesmanEdit.vue?vue&type=script&lang=js"
export * from "./SalesmanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b23434",
  null
  
)

export default component.exports